module.exports = __webpack_public_path__ + "static/spokoj_logo_new-43185913804ae0b08e3444c05b556baf.svg";